import React from 'react';

const BrutalistInput = ({
  placeholder,
  label,
  value,
  onChange,
  style = {},
  maxWidth,
  className = '',
  error = '',
  id,
}) => {
  const errorId = id ? `${id}-error` : undefined;

  return (
    <div style={{ marginBottom: label ? '1rem' : 0 }}>
      {label && (
        <label
          htmlFor={id}
          style={{
            display: 'inline-block',
            backgroundColor: '#000',
            color: '#faf9ea',
            padding: '4px 12px',
            fontWeight: 'bold',
            transform: 'rotate(-1deg)',
            marginBottom: '4px',
          }}
        >
          {label}
        </label>
      )}
      <input
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={className}
        aria-invalid={Boolean(error) || undefined}
        aria-describedby={error && errorId ? errorId : undefined}
        style={{
          width: '100%',
          maxWidth: maxWidth || '100%',
          padding: '12px',
          fontSize: '1rem',
          fontWeight: 'bold',
          border: error ? '4px solid #b91c1c' : '4px solid #000',
          boxShadow: '4px 4px 0 #000',
          ...style,
        }}
      />
      {error ? (
        <p
          id={errorId}
          role="alert"
          style={{ color: '#b91c1c', fontWeight: 700, fontSize: 12, marginTop: 6 }}
        >
          {error}
        </p>
      ) : null}
    </div>
  );
};

export default BrutalistInput;
